import React from 'react';
import { useSelector } from 'react-redux';

import { AvailableCount as AvailableCountBase } from '@swf/poker';

import { usePokerMultiTableTournamentsWidget } from '../../../model';

const AvailableCount = () => {
  const { widgetSelect } = usePokerMultiTableTournamentsWidget();
  const tableRowsCount = useSelector(widgetSelect.getTableRowsCount);

  return <AvailableCountBase count={tableRowsCount} />;
};

export default AvailableCount;
